import { postRequest } from "../../config/axiosConfig";
import { accessToken, getToken } from "../../utils/tokenUtils";

export const createPatientSignup = async ({
  title,
  name,
  email,
  mobile,
  password,
  gender,
  dob,
  address,
  hospital_branch_id,
}) => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "auth/patient/signup",
      data: {
        title,
        name,
        email,
        mobile,
        password,
        gender,
        dob,
        address,
        hospital_branch_id,
      },
    });

    if (response?.status === 201) {
      return {
        success: true,
        data: response,
        message: "Patient signup Successfull!",
      };
    }
    return {
      success: false,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid signup attempt for patient.",
    };
  }
};

export const doPatientLogin = async ({ phone, password, longitude, latitude }) => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "auth/patient/login",
      data: {
        mobile: phone,
        password,
        latitude,
        longitude
      },
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "Patient Login Successfull!",
      };
    }
    return {
      success: false,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid signup attempt for patient.",
    };
  }
};


export const doPatientLogout = async () => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "auth/patient/logout",
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "Logged out Successfully!",
      };
    }
    return {
      success: false,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid logout attempt.",
    };
  }
};


export const patientForgotPassword = async ({ forgotPhone }) => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "password/forgot-patient-password",
      data: {
        mobile: forgotPhone
      },
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "Otp send Successfully!",
      };
    }
    else {
      return {
        success: false,
        data: response,
      };
    }

  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid otp attempt",
    }

  }
}


export const patientVerifyOtp = async ({ otp, phone }) => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "password/verify-patient-otp",
      data: {
        mobile: phone,
        otp: otp,
      },
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "Otp Verified",
      };
    }
    else {
      return {
        success: false,
        data: response,
      };
    }

  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid otp attempt",
    }

  }
}


export const patientResetPassword = async ({ newPassword, confirmPassword, tempToken }) => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "password/reset-patient-password",
      data: {
        new_password: newPassword,
        confirm_password: confirmPassword,
        tempToken: tempToken,
      },
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "Otp send Successfully!",
      };
    }
    else {
      return {
        success: false,
        data: response,
      };
    }

  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid otp attempt",
    }

  }
}